import { render } from "./releases.vue?vue&type=template&id=5eda7b41&scoped=true"
import script from "./releases.vue?vue&type=script&lang=js"
export * from "./releases.vue?vue&type=script&lang=js"

import "./releases.vue?vue&type=style&index=0&id=5eda7b41&scoped=true&lang=css"
import "./releases.vue?vue&type=style&index=1&id=5eda7b41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eda7b41"]])

export default __exports__